import React from "react";
import { Col, Row } from "react-bootstrap";

import { useAppStore } from "../../providers/AppStoreProvider";

import "./SupportBanner.scss";

export const SupportBanner = ({ simple }) => {
  const store = useAppStore();
  const containerClasses =
    "support-banner d-flex align-items-center bg-gradient-purple rounded-10 mx-0 p-4";

  return (
    <Row className={`${containerClasses} ${!simple && "px-3 px-lg-5"}`}>
      <Col lg={{ span: 8 }} md={{ span: 12 }}>
        <h4 className="fw-semibold">Chúng tôi luôn ở đây hỗ trợ bạn</h4>
        <p className={`fw-light mt-2 w-75 ${simple && "fs-7"}`}>
          Nếu trong quá trình thực hành, bạn cần hỗ trợ nhanh chóng, bạn hãy inbox ngay cho ColorME
          nhé, sẽ có người hỗ trợ bạn trong chốc lát
        </p>
        <div className="d-flex flex-column flex-lg-row mt-lg-4">
          <a
            href="https://m.me/colormesupport"
            className="support-btn fw-bold text-center rounded-pill mb-2 m-lg-0 me-lg-2"
          >
            <span>Yêu cầu hỗ trợ</span>
          </a>
          {!simple && (
            <div
              role="button"
              className="report-btn text-center rounded-pill"
              onClick={store.reportModal.toggle}
            >
              Báo lỗi
            </div>
          )}
        </div>
      </Col>
      <Col lg={{ span: 4 }} md={{ span: 12 }}>
        <img
          className="hide-on-phone w-100"
          src="http://d1j8r0kxyu9tj8.cloudfront.net/files/1598858152YZRUXTs0Vv9HdGI.png"
        />
      </Col>
    </Row>
  );
};
